module.exports = __webpack_public_path__ + "static/media/BrightBee_Mäklarhuset-Logo.ece7f588.png";